import aiGaTomaranaiCover from '@/assets/images/records/ai-ga-tomaranai.jpg';
import boogieWoogieCover from '@/assets/images/records/boogie-woogie-lonesome-high-heel.jpg';
import cologneCover from '@/assets/images/records/cologne.jpg';
import crimsonCover from '@/assets/images/records/crimson.jpg';
import danceInTheMemoriesCover from '@/assets/images/records/dance-in-the-memories.jpg';
import flydayChinatownCover from '@/assets/images/records/flyday-chinatown.jpg';
import forYouCover from '@/assets/images/records/for-you.jpg';
import fourAmCover from '@/assets/images/records/four-am.jpg';
import fullMoonCover from '@/assets/images/records/full-moon.jpg';
import goldenBestAkemiIshiiCover from '@/assets/images/records/golden-best-akemi-ishii.jpg';
import heartWaModoranaiCover from '@/assets/images/records/heart-wa-modoranai.jpg';
import heavenBeachCover from '@/assets/images/records/heaven-beach.jpg';
import koiNiOchiteCover from '@/assets/images/records/koi-ni-ochite.jpg';
import lotosCover from '@/assets/images/records/lotos.jpg';
import mayonakaNoDoorCover from '@/assets/images/records/mayonaka-no-door.jpg';
import midnightPretendersCover from '@/assets/images/records/midnight-pretenders.jpg';
import miroirCover from '@/assets/images/records/miroir.jpg';
import missGCover from '@/assets/images/records/miss-g.jpg';
import mizuiroNoAmeCover from '@/assets/images/records/mizuiro-no-ame.jpg';
import musicGreetingsVolumeOneCover from '@/assets/images/records/music-greetings-volume-one.jpg';
import quietEmotionCover from '@/assets/images/records/quiet-emotion.jpg';
import rideOnTimeCover from '@/assets/images/records/ride-on-time.jpg';
import sachetCover from '@/assets/images/records/sachet.jpg';
import sexyRobotCover from '@/assets/images/records/sexy-robot.jpg';
import timelyCover from '@/assets/images/records/timely.jpg';
import varietyCover from '@/assets/images/records/variety.jpg';

export const favoriteAlbums = [
  {
    artist: '杏里 / ANRI',
    cover: timelyCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · LP',
    highlight: 'Remember Summer Days',
    label: 'FOR LIFE',
    note: 'Five saved tracks make this the clearest album-level signal in the playlist: bright surfaces, precise grooves, and summer melancholy.',
    released: '1983.12.05',
    title: 'Timely!!'
  },
  {
    artist: '石井明美 / Akemi Ishii',
    cover: goldenBestAkemiIshiiCover,
    evidence: 'FIRST TIER',
    format: 'COMPILATION · CD',
    highlight: '瞳で抱いてて',
    label: 'SONY MUSIC DIRECT',
    note: 'Four saved tracks make this the second-strongest album signal, spanning tropical dance-pop, polished ballads, and late-eighties rhythm.',
    released: '2007.01.24',
    title: 'ゴールデン☆ベスト 石井明美セレクション'
  },
  {
    artist: '中森明菜 / Akina Nakamori',
    cover: crimsonCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · LP',
    highlight: 'ミック・ジャガーに微笑みを',
    label: 'WARNER PIONEER',
    note: 'Three deep cuts and several alternate interpretations reveal a preference for controlled drama over obvious spectacle.',
    released: '1986.12.24',
    title: 'CRIMSON'
  },
  {
    artist: '具島直子 / Naoko Gushima',
    cover: missGCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · CD',
    highlight: 'モノクローム',
    label: 'TOSHIBA EMI',
    note: 'Soft-focus soul and intimate restraint make this debut a direct bridge from eighties city pop into nineties urban mellow.',
    released: '1996.06.05',
    title: 'miss. G'
  },
  {
    artist: '具島直子 / Naoko Gushima',
    cover: quietEmotionCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · CD',
    highlight: 'まどろみ',
    label: 'TOSHIBA EMI',
    note: 'Three saved album tracks deepen the same late-night language: close vocals, suspended time, and emotion kept just below the surface.',
    released: '1997.10.29',
    title: 'Quiet Emotion'
  },
  {
    artist: '当山ひとみ / Hitomi Tohyama',
    cover: sexyRobotCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · LP',
    highlight: 'BEHIND YOU',
    label: 'NIPPON COLUMBIA',
    note: 'Three saved tracks confirm the appeal of tightly engineered boogie, machine-clean rhythm, and a voice with real warmth.',
    released: '1983.10.21',
    title: 'SEXY ROBOT'
  },
  {
    artist: '葛谷葉子 / Yoko Kuzuya',
    cover: musicGreetingsVolumeOneCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · CD',
    highlight: 'Natural',
    label: 'EPIC / SO WHAT?',
    note: 'Three saved non-singles show that the collection’s urban-soul interest continues well beyond the familiar eighties canon.',
    released: '1999.09.22',
    title: 'MUSIC GREETINGS VOLUME ONE'
  },
  {
    artist: '門あさ美 / Asami Kado',
    cover: sachetCover,
    evidence: 'FIRST TIER',
    format: 'STUDIO ALBUM · LP',
    highlight: '予告状（はじめての手紙）',
    label: 'TEICHIKU / YAMAHA',
    note: 'Three album cuts favour conversational vocals and elegant understatement—the quieter, more private edge of city pop.',
    released: '1980.10.05',
    title: 'Sachet'
  },
  {
    artist: '中原めいこ / Meiko Nakahara',
    cover: lotosCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: '今夜だけDance・Dance・Dance',
    label: 'EASTWORLD / EMI',
    note: 'The collection’s most-played artist at her most vivid: Latin-pop heat, sharp hooks, and a self-authored cosmopolitan world.',
    released: '1984.07.21',
    title: 'ロートスの果実 -LOTOS-'
  },
  {
    artist: '杏里 / ANRI',
    cover: heavenBeachCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: 'Last Summer Whisper',
    label: 'FOR LIFE',
    note: 'The second ANRI album earns its place through the playlist’s coastal side: softer motion, blue-hour atmosphere, and lingering summer memory.',
    released: '1982.11.21',
    title: 'Heaven Beach'
  },
  {
    artist: '竹内まりや / Mariya Takeuchi',
    cover: varietyCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: 'プラスティック・ラブ',
    label: 'MOON RECORDS',
    note: 'The playlist follows these songs through originals, covers, and live versions, treating songwriting as the lasting centre.',
    released: '1984.04.25',
    title: 'VARIETY'
  },
  {
    artist: '菊池桃子 / Momoko Kikuchi',
    cover: miroirCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · CD',
    highlight: 'ドリーム・ボートが出る夜に',
    label: 'VAP RECORDS',
    note: 'The soft, slightly distant vocal presence turns polished adult pop into something private, reflective, and dreamlike.',
    released: '1991.03.03',
    title: 'Miroir―鏡の向こう側に―'
  },
  {
    artist: '八神純子 / Junko Yagami',
    cover: fullMoonCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: '黄昏のBAY CITY',
    label: 'DISCOMATE',
    note: 'A precise, luminous pop record whose dramatic voice and nocturnal harbour atmosphere join both sides of the collection.',
    released: '1983.12.05',
    title: 'FULL MOON'
  },
  {
    artist: '山下達郎 / Tatsuro Yamashita',
    cover: forYouCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: 'MUSIC BOOK',
    label: 'AIR / RVC',
    note: 'A compact studio ideal where guitar sparkle, vocal craft, and finely balanced rhythm turn technical polish into sunlight.',
    released: '1982.01.21',
    title: 'FOR YOU'
  },
  {
    artist: '山下達郎 / Tatsuro Yamashita',
    cover: rideOnTimeCover,
    evidence: 'CORE ARTIST',
    format: 'STUDIO ALBUM · LP',
    highlight: 'RIDE ON TIME (Album Version)',
    label: 'AIR / RVC',
    note: 'Its album version matters in a playlist that notices arrangement changes and follows songs across different recordings.',
    released: '1980.09.19',
    title: 'RIDE ON TIME'
  }
];

export const favoriteTracks = [
  {
    artist: '松原みき / Miki Matsubara',
    cover: mayonakaNoDoorCover,
    note: 'Repeated original, single, and cover entries make this the clearest gateway into the playlist’s neon-night vocabulary.',
    released: '1979.11.05',
    signal: 'URBAN NIGHT',
    source: 'ORIGINAL SINGLE',
    title: '真夜中のドア〜Stay With Me'
  },
  {
    artist: '泰葉 / Yasuha',
    cover: flydayChinatownCover,
    note: 'Its city lights, piano drive, and poised vocal drama capture the collection’s outward-facing, cinematic side.',
    released: '1981.09.21',
    signal: 'CITY LIGHTS',
    source: 'ORIGINAL SINGLE',
    title: 'フライディ・チャイナタウン'
  },
  {
    artist: '大貫妙子 / Taeko Onuki',
    cover: fourAmCover,
    note: 'A deep album cut chosen for atmosphere rather than fame: sparse, sophisticated, and suspended in the hour before dawn.',
    released: '1978.09.21',
    signal: 'LATE-NIGHT AOR',
    source: 'MIGNONNE',
    title: '4:00 A.M.'
  },
  {
    artist: '亜蘭知子 / Tomoko Aran',
    cover: midnightPretendersCover,
    note: 'Cool vocal distance and a shadowy boogie pulse embody the nocturnal restraint that runs through the collection.',
    released: '1983.05.28',
    signal: 'NOCTURNAL BOOGIE',
    source: '浮遊空間',
    title: 'Midnight Pretenders'
  },
  {
    artist: '中原めいこ / Meiko Nakahara',
    cover: danceInTheMemoriesCover,
    note: 'A key track from the playlist’s most represented artist, joining melodic pop immediacy with anime-era memory.',
    released: '1988.01.25',
    signal: 'ANIME CITY POP',
    source: '鏡の中のアクトレス',
    title: 'Dance In The Memories'
  },
  {
    artist: '早見優 / Yu Hayami',
    cover: heartWaModoranaiCover,
    note: 'Crisp electronic rhythm and an emotionally reserved delivery add a sharper Hi-NRG edge to the softer AOR centre.',
    released: '1987.03.21',
    signal: 'HI-NRG',
    source: 'ORIGINAL SINGLE',
    title: 'ハートは戻らない'
  },
  {
    artist: '今井美樹 / Miki Imai',
    cover: boogieWoogieCover,
    note: 'A polished metropolitan groove that carries the collection naturally from eighties boogie into adult contemporary pop.',
    released: '1989.05.17',
    signal: 'URBAN BOOGIE',
    source: 'MOCHA under a full moon',
    title: 'Boogie-Woogie Lonesome High-Heel'
  },
  {
    artist: '小林明子 / Akiko Kobayashi',
    cover: koiNiOchiteCover,
    note: 'Both Japanese and English versions appear in the playlist, revealing an interest in how one melody changes with language.',
    released: '1985.08.31',
    signal: 'ADULT CONTEMPORARY',
    source: 'ORIGINAL SINGLE',
    title: '恋におちて -Fall in love-'
  },
  {
    artist: 'Wink',
    cover: aiGaTomaranaiCover,
    note: 'Its compact Eurobeat pulse widens the dance-pop side of the archive without losing the cool, polished vocal surface.',
    released: '1988.11.16',
    signal: 'EUROBEAT',
    source: 'ORIGINAL SINGLE',
    title: '愛が止まらない 〜Turn It Into Love〜'
  },
  {
    artist: '八神純子 / Junko Yagami',
    cover: mizuiroNoAmeCover,
    note: 'A soaring vocal performance and dramatic melodic arc provide the emotional release behind the collection’s composure.',
    released: '1978.09.05',
    signal: 'DRAMATIC POP',
    source: 'ORIGINAL SINGLE',
    title: 'みずいろの雨'
  },
  {
    artist: '中森明菜 / Akina Nakamori',
    cover: crimsonCover,
    note: 'Saved alongside Mariya Takeuchi’s interpretation, this version turns songwriter study into controlled, late-night drama.',
    released: '1986.12.24',
    signal: 'CONTROLLED DRAMA',
    source: 'CRIMSON',
    title: 'OH NO, OH YES!'
  },
  {
    artist: '竹内まりや / Mariya Takeuchi',
    cover: varietyCover,
    note: 'Studio, live, cover, and translated entries all orbit the same composition, making the songwriting itself the collectible object.',
    released: '1984.04.25',
    signal: "SONGWRITER'S CORE",
    source: 'VARIETY',
    title: 'プラスティック・ラヴ'
  },
  {
    artist: '杏里 / ANRI',
    cover: timelyCover,
    note: 'A fast, open-road counterweight to the archive’s midnight songs, carrying summer brightness without losing rhythmic precision.',
    released: '1983.12.05',
    signal: 'COASTAL DRIVE',
    source: 'Timely!!',
    title: 'WINDY SUMMER'
  },
  {
    artist: '石井明美 / Akemi Ishii',
    cover: goldenBestAkemiIshiiCover,
    note: 'One of four saved tracks from the collection, extending city pop into tropical dance floors and humid after-dark colour.',
    released: '2007.01.24',
    signal: 'TROPICAL DANCE',
    source: 'ゴールデン☆ベスト',
    title: '熱帯夜'
  },
  {
    artist: '具島直子 / Naoko Gushima',
    cover: missGCover,
    note: 'An intimate vocal, soft-edged groove, and careful negative space define the nineties urban-soul branch of the collection.',
    released: '1996.06.05',
    signal: 'URBAN SOUL',
    source: 'miss. G',
    title: 'Candy'
  },
  {
    artist: '具島直子 / Naoko Gushima',
    cover: quietEmotionCover,
    note: 'The restrained lift in this deep cut shows how the playlist favours emotion that accumulates quietly instead of arriving all at once.',
    released: '1997.10.29',
    signal: 'QUIET STORM',
    source: 'Quiet Emotion',
    title: 'So high So high'
  },
  {
    artist: '当山ひとみ / Hitomi Tohyama',
    cover: sexyRobotCover,
    note: 'A tactile vocal rides a sharply programmed groove, joining human warmth to the machine-clean side of eighties boogie.',
    released: '1983.10.21',
    signal: 'MACHINE FUNK',
    source: 'SEXY ROBOT',
    title: 'Kissしたい -WANNA KISS-'
  },
  {
    artist: '葛谷葉子 / Yoko Kuzuya',
    cover: musicGreetingsVolumeOneCover,
    note: 'Its sophisticated R&B arrangement confirms that the same nocturnal taste continues into the late nineties rather than ending in 1989.',
    released: '1999.09.22',
    signal: 'NINETIES AOR',
    source: 'MUSIC GREETINGS VOLUME ONE',
    title: 'TRUE LIES'
  },
  {
    artist: '門あさ美 / Asami Kado',
    cover: sachetCover,
    note: 'Conversational phrasing and elegant understatement represent the private, almost secretive edge of the personal city-pop canon.',
    released: '1980.10.05',
    signal: 'PRIVATE CITY POP',
    source: 'Sachet',
    title: 'Mr. K'
  },
  {
    artist: '秋元薫 / Kaoru Akimoto',
    cover: cologneCover,
    note: 'Hard synth surfaces, clipped rhythm, and an unhurried vocal make this the archive’s clearest standalone synth-boogie marker.',
    released: '1986.03.21',
    signal: 'SYNTH BOOGIE',
    source: 'Cologne',
    title: 'Dress Down'
  }
];
